module.exports = __webpack_public_path__ + "static/hook-tutorial.c2499352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hooks/hook-tutorial.png
// module id = 193
// module chunks = 83200411686586 187953635481388